import { useContext, useEffect, useState } from "react";
import api from "../../utils/api";
import { Context } from "../../context/Contex";

export default function UsersSection() {
    const { loggedInUser } = useContext(Context);

    const [allUsers, setAllUsers] = useState([]);
    const [allPermissionss, setAllPermissionss] = useState([]);
    const [createUserMessage, setCreateUserMessage] = useState({ type: '', text: '' });

    useEffect(() => {
        fetchAllUsers();
        fetchPermissionss();
    }, []);


    const fetchAllUsers = async () => {
        try {
            const response = await api.get('/users/all');
            if (response.data.success) {
                setAllUsers(response.data.users);
            }
        } catch (error) {
            console.error('Erro ao buscar usuários:', error);
            setCreateUserMessage({
                type: 'error',
                text: error.response?.data?.message || 'Erro ao buscar usuários'
            });
        }
    };

    const fetchPermissionss = async () => {
        try {
            const response = await api.get('/permissions');
            if (response.data.success) {
                setAllPermissionss(response.data.data);
            }
        } catch (error) {
            console.error('Erro ao buscar usuários:', error);
            setCreateUserMessage({
                type: 'error',
                text: error.response?.data?.message || 'Erro ao buscar usuários'
            });
        }
    };


    const getPermissionByLevel = (permissions, level) => {
        return permissions.find(p => p.level === level);
    };





    if (!loggedInUser) {
        return (
            <div className="profile-error">
                <span>⚠️</span>
                <p>Erro ao carregar dados do usuário</p>
            </div>
        );
    }

    function getContrastTextColor(hexColor) {
        if (!hexColor) return "#000";

        // remove #
        const hex = hexColor.replace("#", "");

        // converte para RGB
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        // cálculo de luminância
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b);

        // limite: quanto maior, mais clara a cor
        return luminance > 186 ? "#000" : "#fff";
    }


    return (
        <div className="section-content">
            <h1>Gerenciamento de Usuários</h1>
            <div className="config-card">
                <h3>Usuários Registrados</h3>
                <div className="users-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Email</th>
                                <th>Tipo</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {allUsers.map((user) => {
                                const permission = getPermissionByLevel(allPermissionss, user.position);
                                return (
                                    <tr key={user._id}>
                                        <td>{user.apelido}</td>
                                        <td>{user.email}</td>

                                        <td>
                                            <span className={`badge ${permission?.color || ""}`} 
                                            style={{
                                                backgroundColor: permission?.color,
                                                color: getContrastTextColor(permission?.color)
                                            }}>
                                                {permission?.name || "Sem permissão"}
                                            </span>
                                        </td>

                                        <td>
                                            <span className="status active">Ativo</span>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>

                    </table>
                </div>
            </div>
        </div>
    );
}